"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineAsyncMicroApp = exports.loadRemoteModule = void 0;
const isAppCached_1 = require("../util/isAppCached");
const runtime_1 = require("@module-federation/runtime");
const loadRemoteModule = async (appName, moduleName) => {
    // Check if the app is cached in the federation instances
    if ((0, isAppCached_1.isAppCached)(appName)) {
        // If cached, use the get method to load the module
        if (typeof window !== 'undefined' && window[appName] && typeof window[appName].get === 'function') {
            try {
                const vueModule = await window[appName]
                    ?.get(`./${moduleName}`)
                    .then((module) => module());
                // Handle Vue 3 components differently
                if (moduleName.includes('vue3')) {
                    return vueModule.createApp;
                }
                // Return the default export for other modules
                return vueModule.default || vueModule;
            }
            catch (error) {
                console.error(`Failed to load cached module ${moduleName} from ${appName}:`, error);
                // Continue to try loading via loadRemote
            }
        }
    }
    else {
        // Load the remote module
        const remotePath = `${appName}/${moduleName}`;
        try {
            const module = await (0, runtime_1.loadRemote)(remotePath);
            // Handle Vue 3 components differently
            if (moduleName.includes('vue3')) {
                return module.createApp;
            }
            // Return the default export for other modules
            return module.default || module;
        }
        catch (error) {
            console.error(`Failed to load remote module ${moduleName} from ${appName}:`, error);
            throw new Error(`Remote module ${moduleName} not found in ${appName}`);
        }
    }
};
exports.loadRemoteModule = loadRemoteModule;
const defineAsyncMicroApp = async (appName, moduleName) => {
    if (!appName?.trim() || !Array.isArray(moduleName) || moduleName.length === 0) {
        throw new Error('Invalid parameters: appName and moduleName array are required');
    }
    // Pre-allocate arrays for better performance
    const results = await Promise.allSettled(moduleName.map(async (module) => {
        if (typeof module !== 'string' || !module.trim()) {
            throw new Error(`Invalid module name: ${module}`);
        }
        const app = await (0, exports.loadRemoteModule)(appName, module);
        if (!app) {
            throw new Error(`Module ${module} loaded but returned undefined`);
        }
        return app;
    }));
    // Pre-allocate arrays with known size
    const loadedModules = new Array(moduleName.length);
    const errors = [];
    let loadedCount = 0;
    // Single pass through results with direct array assignment
    for (let i = 0; i < results.length; i++) {
        const result = results[i];
        if (result.status === 'fulfilled') {
            loadedModules[i] = result.value;
            loadedCount++;
        }
        else {
            const err = result.reason;
            errors.push(err instanceof Error ? err.message : String(err));
        }
    }
    if (errors.length > 0) {
        throw new Error(`Failed to load ${errors.length} module(s): ${errors.join('; ')}`);
    }
    // Verify all modules were loaded
    if (loadedCount !== moduleName.length) {
        throw new Error(`Expected ${moduleName.length} modules but loaded ${loadedCount}`);
    }
    return loadedModules;
};
exports.defineAsyncMicroApp = defineAsyncMicroApp;
//# sourceMappingURL=define-async-app.js.map